<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'股权融资管理'},{name:'基金合作申请列表'}]" :title="'基金合作申请列表'"/> -->
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="未约谈" name="1" v-if="authorities.indexOf('sys:permission:background:fund:cooperation:apply:list:notQuestion')!==-1"></el-tab-pane>
              <el-tab-pane label="已约谈" name="2" v-if="authorities.indexOf('sys:permission:background:fund:cooperation:apply:list:question')!==-1"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">提交日期</span>
						<el-date-picker
						    size="small"
						    v-model="dateS"
                            format="yyyy-MM-dd"
							value-format="yyyy-MM-dd HH:mm:ss"
							type="datetimerange" 
							:default-time="['24:00:00','23:59:59']"
						    range-separator="至"
						    start-placeholder="开始日期"
						    end-placeholder="结束日期">
						</el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <!-- 表格1 -->
            <el-table
                v-show="tab==1"
                :data="tableData"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
				    v-if="authorities.indexOf('sys:permission:background:fund:cooperation:apply:list:notQuestion:button:view')!=-1||
				    authorities.indexOf('sys:permission:background:fund:cooperation:apply:list:notQuestion:button:confirm')!=-1"
                    label="操作"
                    
                    width="200">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain v-if="authorities.indexOf('sys:permission:background:fund:cooperation:apply:list:notQuestion:button:view')!=-1" @click="check(scope.row)">查看</el-button>
                        <el-button size="small" type="primary" class="super" plain v-if="authorities.indexOf('sys:permission:background:fund:cooperation:apply:list:notQuestion:button:confirm')!=-1" @click="audit(scope.row)">确认约谈</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 表格2 -->
            <el-table
                v-show="tab==2"
                :data="tableData"
                @sort-change="sortChange"
                ref="multipleTable"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    
                    width="100"
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    width="200"
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="modifyUserName"
                    show-overflow-tooltip
                    
                    label="操作账号">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="操作时间">
                </el-table-column>
                <el-table-column
				  v-if="authorities.indexOf('sys:permission:background:fund:cooperation:apply:list:question:button:view')!=-1"
                    label="操作"
                    
                    width="100">
                    <template slot-scope="scope">
                        <el-button v-if="authorities.indexOf('sys:permission:background:fund:cooperation:apply:list:question:button:view')!=-1" size="small" type="primary" class="super" plain  @click="check(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看明细 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogInfo"
                :close-on-click-modal="false"
                width="50%">
                <div class="basic">
                    <div class="boxChild">
                        <div class="basisTitle">提交信息</div>
                        <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{checkInfo.applicant}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{checkInfo.contactPhone}}</div>
                        </div>
                        <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{checkInfo.applyCompany}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{checkInfo.applyRemark}}</div>
                        </div>
                        <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,i) in checkInfo.fileList" :key="i">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                                </li>
                                <!-- <li><span>附件名称附件名称附件名称附件名称附件名称附件名称.docx</span><i class="el-icon-download" @click="downLoad()"></i></li>
                                <li><span>附件名称附件名称附件名称附件名称附件名称附件名称.docx</span><i class="el-icon-download" @click="downLoad()"></i></li>
                                <li><span>附件名称附件名称附件名称附件名称附件名称附件名称.docx</span><i class="el-icon-download" @click="downLoad()"></i></li> -->
                            </ul>
                        </div>
                        <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{checkInfo.createTime}}</div>
                        </div>
                    </div>
                    <div class="boxChild" v-if="tab==2">
                        <div class="basisTitle">操作记录</div>
                        <div class="child">
                            <div class="name">操作账号：</div>
                            <div class="content">{{checkInfo.modifyUserName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">操作时间：</div>
                            <div class="content">{{checkInfo.updateTime}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{checkInfo.checkExplanation}}</div>
                        </div>
                    </div>
                </div>
            </el-dialog>
            <!-- 确认已约谈 -->
            <el-dialog
                title="确认已约谈"
                :visible.sync="dialogAudit"
                :close-on-click-modal="false"
                width="30%">
                <div class="forms">
                    <div class="hint">提示：确认已约谈后不可更改，请谨慎操作</div>
                    <div class="childTextarea">
                        <div class="name">说明：</div>
                        <div class="content"><el-input type="textarea" v-model="sendInfoTwo.remark" show-word-limit maxlength="200" style="max-width:100%;"></el-input></div>
                    </div>
                    <div class="doubleBtn">
                        <el-button size="small" type="primary" @click="submit">确认</el-button>
                        <el-button size="small" @click="cancel">取消</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import timeMixins from "@/mixins/timeFormat";
export default {
    mixins:[timeMixins],
    components:{
        // breadcrumb
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
            options: [{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '姓名'
            }, {
                value: '4',
                label: '申请人姓名'
            }, {
                value: '5',
                label: '联系方式'
            }],//检索下拉
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                endDate:'',//结束时间
                startDate:'',//开始时间
                id:"",//申请id
                userName:'',//账号
                name:'',//姓名
                applicant:'',//申请人姓名
                contactPhone:'',//联系手机号
                property:null,//排序字段
                direction:null,//排序方式
            },//检索提交数据
            tab:'1',//选项卡
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            dialogAudit:false,//确认已约谈弹出层
            dialogDetail:false,//表格内详情弹出层
            sendInfoTwo:{
                applyId:"",
                remark:'',//说明
            },//确认已约谈提交数据
            checkInfo:{
                applicant:"",//申请人姓名：
                contactPhone:"",//联系手机号：
                applyCompany:"",//公司全称：
                applyRemark:"",//说明：
                fileList:[],//附件
                createTime:"",//提交时间：
                modifyUserName:"",//申请人姓名：
                updateTime:"",//操作时间：
                checkExplanation:"",//说明：
            },
            scopeList:[],
            scopeListArray:[],
            totalSize:null
        }
    },
    methods:{
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
          onReset(){
            this.getSelect='';//检索下拉的值
            this.getValue='';//检索输入框的值
            this.dateS=[];//日期
            this.sendInfoOne.currentPage=1;//当前页
            this.sendInfoOne.pageSize=20;//页条数
            this.sendInfoOne.endDate='';//结束时间
            this.sendInfoOne.startDate='';//开始时间
            this.sendInfoOne.id="";//申请id
            this.sendInfoOne.userName='';//账号
            this.sendInfoOne.name='';//姓名
            this.sendInfoOne.applicant='';//申请人姓名
            this.sendInfoOne.contactPhone='';//联系手机号
            this.totalSize=null;//总页码
            this.getData();
          },
        // 切换选项啦
        changeTab:function(tab){
            this.tab=tab.name;
            this.onReset()
        },
        //检索事件
        retrieval:function(){},
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='asc';
            }else{
                order='desc';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        //查看明细
        check:function(row){
            // this.dialogInfo=true
            // this.$axiosc.get('backstage/fund/apply/details/'+row.id).then(res=>{
            //     if(res.code == 200){
            //         this.checkInfo = res.data
            //     }else{
            //         this.$alert(res.msg)
            //     }
            // })
            this.$router.push({path: `/equityManagement/applyList/detail/${this.tab}`, query: {id: row.id, index: '/equityManagement/applyList'},param:{type:this.tab}})

        },
        //下载附件
        downLoad:function(){},
        //打开确认已约谈
        audit:function(row){
            this.sendInfoTwo.applyId = row.id
            this.dialogAudit=true;
        },
        //取消按钮
        cancel:function(){
            this.dialogAudit=false
        },
        //保存按钮
        submit:function(){
            this.$axiosc.post('backstage/fund/apply/interview',this.$qs.stringify(this.sendInfoTwo)).then(res=>{
                if(res.code == 200){
                    this.getData()
                    this.$message({
                        type: 'success',
                        message: '约谈成功'
                    });
                    this.dialogAudit=false
                }else{
                    this.$message({
                        type: 'error',
                        message: '约谈失败'
                    });
                }
            })
        },
        getData(){
            this.loading = true
            if(this.dateS&&this.dateS.length>0){
                this.sendInfoOne.startDate=this.dateS[0];
                this.sendInfoOne.endDate=this.dateS[1];
            }else{
                this.sendInfoOne.startDate=null;
                this.sendInfoOne.endDate=null;
            }
            this.sendInfoOne.id="";//申请id
            this.sendInfoOne.userName='';//账号
            this.sendInfoOne.name='';//姓名
            this.sendInfoOne.applicant='';//申请人姓名
            this.sendInfoOne.contactPhone='';//联系手机号
            if(this.getSelect=='1'){ //申请id
                this.sendInfoOne.id=this.getValue;
            }else if(this.getSelect=='2'){ //账号
                this.sendInfoOne.userName=this.getValue;
            }else if(this.getSelect=='3'){ //姓名
                this.sendInfoOne.name=this.getValue;
            }else if(this.getSelect=='4'){ //申请人姓名
                this.sendInfoOne.applicant=this.getValue;
            }
            else if(this.getSelect=='5'){ //联系方式
                this.sendInfoOne.contactPhone=this.getValue;
            }
            let url='';
            this.scopeList = []
            if(this.tab==1){
                url='backstage/fund/apply/notTalking/list';
            }else{
                url='backstage/fund/apply/have/been/interviewed/list';
            }
            this.$axiosc.get(url,{params:this.sendInfoOne}).then((r)=>{
                this.loading = false
                if(r.code==200){
                    this.tableData=r.data.content;
                    this.totalSize=r.data.totalElements;
                }else{
                    this.$alert(r.msg)
                }
            }).catch(e=>{
              this.loading = false
            })
        }
    },
    mounted(){
        const that = this
        // 未约谈
        if(that.authorities.indexOf('sys:permission:background:fund:cooperation:apply:list:notQuestion')==-1){
            that.tab='2'
        }
        // 待审核 和审核记录存在一个
        if(that.authorities.indexOf('sys:permission:background:fund:cooperation:apply:list:notQuestion')!=-1||
            that.authorities.indexOf('sys:permission:background:fund:cooperation:apply:list:question')!=-1){
            that.getData();
        }
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>

<style lang="scss" scoped>

</style>